import type { schemas } from '@gonfalon/openapi/types';
import { Button, DialogTrigger, Popover } from '@launchpad-ui/components';

import { CodeSpan } from '../CodeSpan';

import styles from './EventDataPreview.module.css';

export function EventContextKinds({ contexts }: { contexts: schemas['MetricEventDefinitionInstance']['contexts'] }) {
  if (!Array.isArray(contexts) || contexts.length === 0) {
    return null;
  }

  return (
    <div className={styles.contextKindsCell}>
      <CodeSpan textValue={contexts[0]?.context_kind ?? ''} />
      {contexts.length > 1 && (
        <DialogTrigger>
          <Button size="small" variant="minimal" className={styles.contextsMoreButton}>
            +{contexts.length - 1}
          </Button>
          <Popover className={styles.contextsPopover}>
            {contexts.slice(1).map((context) => {
              if (context?.context_kind) {
                return <CodeSpan key={context.context_kind} textValue={context.context_kind} />;
              }
              return null;
            })}
          </Popover>
        </DialogTrigger>
      )}
    </div>
  );
}
